/* eslint-disable no-undef */
export default {
	name: "reason-for-order-rejection-modal",
	props: ["heading", "modalId", "showModal", "orderId", "orderDeliveryId"],
	emits: ["okButtonClicked"],
	data() {
		return {
			orderDelivery: {},
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false
		};
	},
	methods: {
		getReasonForOrderRejection() {
			orderService.getOrderForDelivery(this.orderId, this.orderDeliveryId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.orderDelivery = successResponse.data.result;
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onOkClick(){
			this.$emit("okButtonClicked", true)
		}
	},
	mounted: function () {
        
	},
	watch: {
		orderId:{
			handler: function () {
				if(this.orderId !== null && this.orderId > 0){
					this.getReasonForOrderRejection();
				}
			},
			immediate: true,
			deep: true
		},
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				if (this.showModal) {
					$("#" + this.modalId).modal("show");
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		}
	}
};
